import { render, staticRenderFns } from "./FormatPageObjectMenu.vue?vue&type=template&id=ecc08854&scoped=true&"
import script from "./FormatPageObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./FormatPageObjectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageObjectMenu.vue?vue&type=style&index=0&id=ecc08854&lang=scss&scoped=true&"
import style1 from "./FormatPageObjectMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc08854",
  null
  
)

export default component.exports